import React from 'react';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  const imagekit = import.meta.env.VITE_IMAGEKIT_URL;
  return (
    <>
      <div
        className="min-h-screen bg-black text-white flex flex-col p-5 overflow-hidden"
        style={{
          backgroundImage: `url(${imagekit}/bg.webp)`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Rotated background image */}
        {/* <div
          className="absolute inset-0 z-0  origin-center"
         
        /> */}

        {/* Logo */}
        <img src={`${imagekit}/logo.svg`} alt="" className="w-40 relative z-10" />

        {/* Centered Section */}
       <div className="flex-grow flex items-center justify-center relative z-10">
          <div className=" relative max-w-[560px] w-full mx-auto flex-center flex-col">
            <img src={`${imagekit}/logo.svg`} alt="" className="w-80 relative z-10 mb-8 mx-auto" />
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
